module.exports = __webpack_public_path__ + "img/non-smoker.6f2bc575.svg";